import React from 'react';
import './Loader.scss';

const Loading = (props) => {
    return (
        <div className="content">
            {props && props.textLoading &&
            <div className="textloading">
                Please wait while we fetch details.<br/>Kindly do not refresh the page
            </div>
            }
            <div className="column">
                <div className="containers animation-5">
                    <div className="shape shape1"></div>
                    <div className="shape shape2"></div>
                    <div className="shape shape3"></div>
                    <div className="shape shape4"></div>
                </div>
            </div>
        </div>
    )
}

export default Loading;